export const AccessRestrictionType = {
  EXPIRED: 'expired',
  NOT_STARTED: 'not_started',
  UNKNOWN: 'unknown'
} as const;

export type AccessRestrictionType = typeof AccessRestrictionType[keyof typeof AccessRestrictionType];

export const SessionStorageKeys = {
  AUTH_MODE: 'auth_mode',
  AUTH_TIMESTAMP: 'auth_timestamp',
  QR_SIGN_IN_CODE: 'qr_sign_in_code',
  QR_ORIGINAL_URL: 'qr_original_url'
} as const;

export type SessionStorageKeys = typeof SessionStorageKeys[keyof typeof SessionStorageKeys];

export interface QRCodeError {
  type: AccessRestrictionType;
  message: string;
  startDate?: string | number;
  endDate?: string | number;
}

export function isQRCodeError(error: any): error is QRCodeError {
  return error && Object.values(AccessRestrictionType).includes(error.type);
}